import { useEffect, useState } from "preact/hooks";

type BuildInfo = {
  version: string;
  commit: string;
  region: string;
  environment: string;
};

export function App() {
  const [count, setCount] = useState(0);
  const [build, setBuild] = useState<BuildInfo | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Proves the client and the Bun server are talking to each other. If the
    // ingress or the service is misrouted, this is what fails first.
    fetch("/api/build")
      .then((r) => {
        if (!r.ok) throw new Error(`GET /api/build returned ${r.status}`);
        return r.json() as Promise<BuildInfo>;
      })
      .then(setBuild)
      .catch((e: unknown) => setError(e instanceof Error ? e.message : String(e)));
  }, []);

  return (
    <main>
      <h1>ajt-web-app-experiment</h1>
      <p>A Preact single-page app served by a Bun HTTP server.</p>

      <section>
        <h2>Web Client</h2>
        <button type="button" onClick={() => setCount((c) => c + 1)}>
          Clicked {count} {count === 1 ? "time" : "times"}
        </button>
      </section>

      <section>
        <h2>Server</h2>
        {error && <p class="error">Cannot reach the server: {error}</p>}
        {!error && !build && <p>Loading…</p>}
        {build && (
          <dl>
            <dt>Environment</dt>
            <dd>{build.environment}</dd>
            <dt>Region</dt>
            <dd>{build.region}</dd>
            <dt>Version</dt>
            <dd>{build.version}</dd>
            <dt>Commit</dt>
            <dd><code>{build.commit}</code></dd>
          </dl>
        )}
      </section>
    </main>
  );
}
